import { useQuery } from '@tanstack/react-query';

import { AllowListItem } from 'src/features/allowList/utils/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = 'sp-core/:parkingId/allow-lists/allow-list/:listId/allow-list-items';

type QueryFnType = typeof queryFn;
interface DTO extends ListDTO {
    listId: string;
    parkingId: string;
}
const queryFn = ({ listId, parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<AllowListItem>> => {
    return axios.get(formatResourcePath(RESOURCE, { listId, parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_ALLOW_LIST_ITEMS_RESOURCE, useQueryHook as useListAllowListItems };
